// AppLayout.js
import React, { useEffect } from 'react';
import Header from 'components/common/Header';
import Footer from 'components/common/Footer';
import AdminHeader from 'components/common//AdminHeader';
import DefaultLayout from './DefaultLayout';
import MainLayout from './MainLayout';
import AdminLayout from './AdminLayout';
import { useSelector } from 'react-redux';
import './app-layout.css';
import { debug } from './../utils';
const AppLayout = ({ children, requireAuth, requireAdmin, sidebar, config = {} }) => {
  const user = useSelector((state) => state.user);
  return (
    <div className="app-layout">

      {requireAdmin ? <AdminHeader /> : <Header />}
      <div className='' id="content">
        {requireAdmin ?
          <AdminLayout
            config={config}
          >{children}</AdminLayout>
          :
          requireAuth ?
            <MainLayout>{children}</MainLayout>
            :
            <DefaultLayout>{children}</DefaultLayout>
        }
      </div>
      {!requireAdmin && <Footer />}
    </div >
  );
}
export default AppLayout;
